import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Typography from '../Typography';

interface MoreMenuProps {
  items: { label: string; onClick: () => void; color?: string; isLoading?: boolean }[];
  disabled?: boolean;
}

const MoreMenu: React.FC<MoreMenuProps> = ({ items, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick} disabled={disabled}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items.map(({ label, onClick, color = 'initial', isLoading = false }) => (
          <MenuItem
            key={label}
            sx={{ minWidth: '160px' }}
            onClick={() => {
              onClick();
              handleClose();
            }}
            disabled={isLoading}
          >
            <Typography sx={{ fontSize: '16px', color: color }}>
              {isLoading ? <CircularProgress size={20} /> : label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MoreMenu;
